import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./global.css";

// Lazy load the main App component for better initial load performance
const App = lazy(() => import("./App.tsx"));

// Import our custom AppSkeleton for a better loading experience
import AppSkeleton from "./components/AppSkeleton";

// Create a function to measure and log performance metrics
const logPerformanceMetrics = () => {
  // Wait until the page has fully loaded
  window.addEventListener('load', () => {
    // Use requestIdleCallback to not block the main thread
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        // Get performance metrics
        const perfEntries = performance.getEntriesByType('navigation');
        if (perfEntries.length > 0) {
          const timing = perfEntries[0] as PerformanceNavigationTiming;
          console.log('FCP:', performance.getEntriesByName('first-contentful-paint')[0]?.startTime);
          console.log('LCP:', performance.getEntriesByName('largest-contentful-paint', 'element')[0]?.startTime);
          console.log('DOM Content Loaded:', timing.domContentLoadedEventEnd - timing.domContentLoadedEventStart);
          console.log('Load Time:', timing.loadEventEnd - timing.fetchStart);
        }
      });
    }
  });
};

// Log performance metrics in development
if (import.meta.env.DEV) {
  logPerformanceMetrics();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<AppSkeleton />}>
      <App />
    </Suspense>
  </StrictMode>
);
